import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';
import type { BannerTheme } from './types';

export const Container = styled.div<{ bgImage: string; clickable: boolean; center: boolean }>`
  ${(props) => props.clickable && 'cursor: pointer'};
  padding: 16px 24px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  background-image: ${(props) => `url(${props.bgImage})`};
  background-size: cover;
  overflow: hidden;
  min-height: 200px;
  ${(props) => props.center && 'text-align: center;'}
`;

export const ContentContainer = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ImageContainer = styled.div<{ hideImage?: boolean }>`
  margin: -16px 32px;
  img {
    max-height: 200px;
    height: 100%;
    object-fit: contain;
  }

  ${mediaQuery('tablet')} {
    display: none;
  }
`;

export const Title = styled.div<{ bannerTheme: BannerTheme }>`
  max-width: 700px;
  font-weight: 700;
  font-size: 24px;
  ${(props) => props.bannerTheme === 'purple' && `color: ${props.theme.color.purple.default};`}
  ${(props) => props.bannerTheme === 'blue' && `color: ${props.theme.color.blue.darkerBlue};`}
`;

export const Text = styled.div`
  font-weight: 500;
  font-size: 14px;
  margin-top: 8px;
`;

export const ButtonContainer = styled.div<{ center: boolean }>`
  display: flex;
  align-items: center;
  margin-top: 24px;
  ${(props) => props.center && 'justify-content:center;'}
  img {
    margin-left: 12px;
    object-fit: contain;
  }
`;
